
import React, { useState }  from 'react';
import { Query } from 'react-apollo';
import { addToDataLayerGTM } from '../../utils/addToDataLayerGTM';
import noImage from '../../noImage.png';
import ErrorModal from '../Modal/ErrorModal';
import { Tooltip, makeStyles, IconButton, Button } from '@material-ui/core';
import ExpandLessRoundedIcon from '@material-ui/icons/ExpandLessRounded';
import ExpandMoreRoundedIcon from '@material-ui/icons/ExpandMoreRounded';

// Utilizado com component Card na view Trail,na view Courses, e em GridCarousel componente da View Home.

const Card = ({
  item, href, client = null, variables= null,
  userQuery= null, type = null, src, min= 0
}) => {

  const [textoExpandido, setTextoExpandido] = useState(false);

  const useStyles = makeStyles((theme) => ({
    customTooltip: {
      backgroundColor: '#F9F3F3',
      color: 'rgba(0, 0, 0, 0.87)',
      maxWidth: 220,
      fontSize: '1.1rem',
      border: '0.5px solid #00A1FC;',
      boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.25)',
      borderRadius: '5px',
    },
  }));

  const classes = useStyles();

  const handleClick = () => {
    setTextoExpandido(!textoExpandido);
  };

  const course_trails = variables && variables.course_trails ? variables.course_trails : false;

  const descricao = item.description;
  let textoAbreviado = descricao;
  if (!textoExpandido && textoAbreviado && textoAbreviado.length > 100) {
    textoAbreviado = textoAbreviado.substr(0, 100);
    textoAbreviado += '...';
  }

  const tooltipContent = (
    <React.Fragment>
      <div>
        {item.description && 
          <div className='paragraph'>
            <b><strong>Conteúdo:</strong> {textoAbreviado} </b>
            <br />
          </div>
        }
        {(item.hours !== undefined && item.hours !== null) || (item.minutes !== undefined && item.minutes !== null) ?
          <div className='paragraph'>
            <b><strong>Duração: </strong> 
              {(item.hours !== null && item.hours !== 0) && `${item.hours} hora(s)`} 
              {(item.hours !== null && item.hours !== 0) && (item.minutes !== null && item.minutes !== 0) && " e "}
              {(item.minutes !== null && item.minutes !== 0) && `${item.minutes} minuto(s).`}
              {((item.hours !== null && item.hours !== 0) && !item.minutes) && "."}
            </b>
            <br />
          </div>
          : null
        }
        {(item.modules && item.modules > 0) && 
          <div className='paragraph'>
            <b><strong>Módulos:</strong> {item.modules}</b>
            <br />
          </div>
        }
      </div>
      {textoAbreviado && textoAbreviado.length > 100 &&
        <div className='btnMore'>
          <IconButton onClick={handleClick}> 
              {textoExpandido ?
                <ExpandLessRoundedIcon color='primary'/>
              : 
                <ExpandMoreRoundedIcon color='primary'/>
              }
          </IconButton>
        </div>
      }
    </React.Fragment>
  );

  return (
    <div id={item.id} className="course-item">
      <a
        data-gtm-type="click"
        data-gtm-clicktype="card"
        data-gtm-name={item.title}
        href={href}>
        <img
          style={{ minHeight: min }}
          src={src}
          onError={({target}) => target.src = noImage}
        />
      </a>
        <div className="divInfo">
          <div className="titleText">
            {item.title}
          </div>
          <div className="titleContent">
            {(item.description || item.hours || item.minutes || item.modules) && course_trails ?
              (
                <Tooltip 
                  title={tooltipContent} 
                  classes={{ tooltip: classes.customTooltip }} 
                  interactive={true}
                >
                  <button className="infoButton">i</button>
                </Tooltip>
              )
              : ( course_trails &&
                    <button className="infoButton infoEmpty">i</button>
                )
            }
          </div>
        </div>

        {type === 'course' && <Query
          client={client}
          variables={variables}
          query={userQuery}
        >
          {({ loading, error, data }) => {
            if (loading) return <div />;
            if (error) {
              // Google Tag Manager
              addToDataLayerGTM({
                'event': 'erro',
                'descricao': 'erro ao buscar itens da trilha do usuario'
              });
            return <ErrorModal />;
          };
          return (
            <div>
              {(data.trail_has_user_item && data.trail_has_user_item.id) && <div className="is_viewed">Concluído</div>}
              {(data.course_has_user_item && data.course_has_user_item.id) && <div className="is_viewed">Concluído</div>}
            </div>
          );
        }}
      </Query>}
    
  </div>
  )
};

export default Card;



// WEBPACK FOOTER //
// ./src/components/CourseCard/index.jsx